/** Public path to the résumé PDF (drop the real file here to replace it). */
const CV_PDF = "/files/casey-mckay-resume.pdf";

/**
 * Résumé / CV page at /cv. Embeds the PDF inline and offers download / open-in-
 * new-tab. To publish a new résumé, replace `frontend/public/files/casey-mckay-
 * resume.pdf` — no code change needed.
 */
export function CvPage() {
  return (
    <div className="page">
      <div className="container">
        <header className="page__head">
          <p className="eyebrow">Curriculum Vitae</p>
          <h1 className="page__title">Résumé</h1>
          <p className="page__intro">
            Casey Scott McKay&rsquo;s résumé. View it below, or download the PDF.
          </p>
        </header>

        <div className="row" style={{ marginBottom: "var(--space-3)" }}>
          <a className="btn" href={CV_PDF} download>
            Download PDF
          </a>
          <a className="btn btn--ghost" href={CV_PDF} target="_blank" rel="noopener noreferrer">
            Open in new tab ↗
          </a>
        </div>

        <object
          className="cv-frame"
          data={CV_PDF}
          type="application/pdf"
          aria-label="Résumé PDF"
        >
          <p className="mono">
            Your browser can&rsquo;t display the PDF inline.{" "}
            <a href={CV_PDF} target="_blank" rel="noopener noreferrer">
              Open the résumé in a new tab
            </a>
            .
          </p>
        </object>
      </div>
    </div>
  );
}
